import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog3 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>
        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        <p className="paragraph-content">
          kPaisa is helping shape a quiet financial shift happening across
          India. Mutual fund investments have surged, touching ₹70.9 lakh crore
          by October 2025 – a 22% rise - thanks to a wave of new investors. Gold
          also delivered solid returns of around 21% in 2024, and more Indians,
          especially younger ones, are now buying digital gold starting from
          just ₹10. With bank interest rates falling behind inflation, people
          are searching for smarter ways to grow their money.
        </p>

        <p className="sub-paragraph-heading">Everything in One Place</p>
        <p className="sub-paragraph-content">
          Having multiple financial tools inside a single app makes life much
          easier. With the kPaisa app, you can invest in mutual funds, buy
          digital gold, get an instant personal loan, and even pay your utility
          bills. The app also includes learning resources and a reward system so
          you can earn as you learn. No paperwork, no hassle - just your
          smartphone.
        </p>

        <p className="sub-paragraph-heading">Simple Enough for Beginners</p>
        <p className="sub-paragraph-content">
          Finance doesn’t have to feel difficult. kPaisa is built especially for
          those who are just starting their investment journey. The founder
          explains, “We empower individuals to take charge of their finances
          regardless of financial literacy.” The app guides you step by step,
          almost like a friendly mentor who simplifies money matters.
        </p>

        <p className="sub-paragraph-heading">
          Let Your Money Grow, Not Sit Idle
        </p>
        <p className="sub-paragraph-content">
          Fixed deposits today offer around 5% interest - ₹10,000 earns you only
          about ₹500 in a year. Compare that with digital gold, which gave
          roughly 21% returns in 2024, potentially turning ₹10,000 into ₹12,100.
          Many mutual funds are also providing strong double-digit returns. So,
          why let your money rest when it could grow with smart investing? And
          who knows - when you check your investments in the future, you might
          just wish you had started sooner.
        </p>

        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>
        <FaqAccordion>
          <h4 className="faq-question">What is kPaisa?</h4>
          <p className="faq-answer">
            It’s a fintech app that lets you invest in mutual funds, buy digital
            gold, take personal loans, and pay bills - all within a single
            platform.
          </p>
        </FaqAccordion>
        <FaqAccordion>
          <h4 className="faq-question">Who should use kPaisa?</h4>
          <p className="faq-answer">
            It’s perfect for first-time investors and people from smaller towns.
            The app is designed so that even those with little financial
            knowledge can start investing easily.
          </p>
        </FaqAccordion>
        <FaqAccordion>
          <h4 className="faq-question">Can I start with a small amount?</h4>
          <p className="faq-answer">
            Yes. You can buy digital gold for as little as ₹10 or begin a mutual
            fund SIP from just ₹100. Small steps can lead to big results over
            time.
          </p>
        </FaqAccordion>
        <br></br>
        <br></br>
      </div>
    </div>
  );
};

export default Blog3;
